// extracted by mini-css-extract-plugin
export var button = "_6h-0";
export var icon = "_6h-1";